import type Big from 'big.js';
import { UnitType } from 'dayjs';

import { theme } from '@cast/design-system';
import { NodeManagedByEnum } from '@cast/types';

import { nodeTypeColors } from 'constants/maps';

export type CostReportNodesSummaryNormalized = {
  cpuOverprovisioning: Big;
  linuxNodeCount: Big;
  managedBy: NodeManagedByEnum;
  ramOverprovisioning: Big;
  windowsNodeCount: Big;
};

export const computeSpendColorsMap = {
  ...nodeTypeColors,
  storage: theme.palette.aqua[300],
};

export enum ComputeSpendType {
  ON_DEMAND = 'onDemand',
  SPOT = 'spot',
  FALLBACK = 'fallback',
  STORAGE = 'storage',
}

export type DataGranularity = {
  step: number;
  unit: Exclude<UnitType, 'date' | 'dates'>;
};
